import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export function createProfileManagementRoutes({ accessLevel } = {}) {
  const isSuperAdminRoute = accessLevel === 'super-admin'
  const metaFor = action => (isSuperAdminRoute ? { permissionAction: action } : undefined)
  const profileBasePath = isSuperAdminRoute ? '/super-admin/profile' : '/admin/profile'

  return [
    {
      path: 'profile',
      component: () => import('@/features/profileManagement/ProfileView.vue'),
      redirect: `${profileBasePath}/settings/change-password`,
      meta: metaFor(PermissionActions.SuperAdminLimitedProfileView),
      children: [
        {
          path: 'settings',
          component: DummyRouter,
          meta: metaFor(PermissionActions.SuperAdminLimitedProfileView),
          children: [
            {
              path: 'social-connect',
              component: () =>
                import('@/features/profileManagement/settings/SocialConnectView.vue'),
              meta: metaFor(PermissionActions.SuperAdminLimitedProfileView),
            },
            {
              path: 'debug',
              component: () => import('@/features/profileManagement/debug/ProfileDebugView.vue'),
              meta: metaFor(PermissionActions.SuperAdminLimitedProfileDebugView),
            },
            {
              path: 'change-password',
              component: () =>
                import('@/features/profileManagement/changePassword/ProfileChangePassword.vue'),
              meta: metaFor(PermissionActions.SuperAdminLimitedProfileChangePassword),
            },
          ],
        },
      ],
    },
  ]
}

export const profileManagementRoutes = createProfileManagementRoutes()
